import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** GET `/aftersales/sign-receipt/next-no` → `data` 字串建議單號。 */
export async function fetchSignReceiptNextNo() {
  const { data: raw } = await request.get('/aftersales/sign-receipt/next-no');
  return parseVer4DetailResponse(raw);
}
